import { create } from 'zustand';

const useStore = create((set) => ({
  workspaceId: 0,
  workspaceType: 'Home',
  workspaceName: '',
  subscription: null,
  workspaceActiveFeatures: ['Todo', 'Calendar', 'Notes'],

  dashboardRefreshTrigger: 0,
  triggerDashboardRefresh: () => set((state) => ({ dashboardRefreshTrigger: state.dashboardRefreshTrigger + 1 })),
}));

export default useStore;